import { ComputeServiceState as ComputeServiceStateSchema } from '@schema';
import { TagType } from '@uikit/ui-kit/types/tag.d';

export const WEBCP = 'webcp';
export const MDS = 'mds';
export const CS = 'cs';
export const COMPUTE = 'compute';
export const ABGW = 'abgw';
export const ISCSI = 'iscsi';
export const S3 = 's3';
export const NFS = 'nfs';
export const FILE_STORAGE = 'mpfs';
export const VHS_COMPUTE = 'vhs_compute';

export const enum NODE_SERVICE_STATUS {
  MAINTENANCE = 'maintenance',
  FAILED = 'failed',
  SLOW = 'slow',
  HEALTHY = 'healthy'
}

export const enum NODE_SERVICE_TYPE {
  INTERNAL = 'internal',
  EXTERNAL = 'external'
}

export const NODE_SERVICE_TAG_TYPE: Record<NODE_SERVICE_STATUS, TagType> = {
  [NODE_SERVICE_STATUS.MAINTENANCE]: 'warning',
  [NODE_SERVICE_STATUS.FAILED]: 'danger',
  [NODE_SERVICE_STATUS.SLOW]: 'warning',
  [NODE_SERVICE_STATUS.HEALTHY]: 'success'
};

export const COMPUTE_NODE_SERVICE_TAG_TYPE: Record<ComputeServiceStateSchema, TagType> = {
  [ComputeServiceStateSchema.CRITICAL]: 'danger',
  [ComputeServiceStateSchema.DISABLED]: 'warning',
  [ComputeServiceStateSchema.HEALTHY]: 'success',
  [ComputeServiceStateSchema.OFFLINE]: 'inactive'
};
